import React from 'react'
import { Link } from 'react-router-dom'
import { ShieldOffIcon } from 'lucide-react'

export function AccessDenied() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4">
      <div className="max-w-md text-center space-y-4">
        <div className="mx-auto w-14 h-14 rounded-full bg-red-50 text-red-600 flex items-center justify-center">
          <ShieldOffIcon className="w-7 h-7" />
        </div>
        <h1 className="text-2xl font-bold text-gray-900">Access denied</h1>
        <p className="text-gray-600">
          You do not have permission to view this page, or the module is disabled for your organization.
        </p>
        <Link
          to="/dashboard"
          className="inline-flex px-4 py-2 rounded-lg bg-blue-600 text-white text-sm font-medium hover:bg-blue-700"
        >
          Back to dashboard
        </Link>
      </div>
    </div>
  )
}

export default AccessDenied